import { Button } from "@/components/ui/button/button";

import { DesignSnackHeaderAndTab } from "../../../_shared/ui/header-and-tab";

type Props = {
	hotelID: string;

	onUpdate: () => Promise<void>;
	isValid: boolean;
};

export const DesignSnackSettingsHeaderAndTabs = ({ hotelID, onUpdate, isValid }: Props) => {
	return (
		<DesignSnackHeaderAndTab
			hotelID={hotelID}
			title="スナックページの設定"
			headerProps={{
				rightChildren: (
					<Button size="xl" type="button" variant={isValid ? "default" : "disabled"} onClick={onUpdate}>
						保存
					</Button>
				),
			}}
		/>
	);
};

DesignSnackSettingsHeaderAndTabs.displayName = "DesignSnackSettingsHeaderAndTabs";
